import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import _ from 'lodash';

import icon from '../../assets/icon_edit.svg';

interface User {
  userId: string;
  displayName: string;
  fullName: string;
  email: string;
  referralCode?: string;
}

interface UserProfileCardProps {
  user: User | null;
}

const UserProfileCard: React.FC<UserProfileCardProps> = ({ user }) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = async () => {
    if (user && user.referralCode) {
      if (navigator.clipboard) {
        try {
          await navigator.clipboard.writeText(user.referralCode);
          setIsCopied(true);
          setTimeout(() => setIsCopied(false), 2000);
        } catch (err) {
          console.error('클립보드 복사 실패:', err);
        }
      } else {
        const textArea = document.createElement('textarea');
        textArea.value = user.referralCode;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
          document.execCommand('copy');
          setIsCopied(true);
          setTimeout(() => setIsCopied(false), 2000);
        } catch (err) {
          console.error('대체 복사 방식 실패:', err);
        }
        document.body.removeChild(textArea);
      }
    }
  };

  return (
    <section className="setting-section">
      <div className="section-header">
        <h2>계정&개인정보</h2>
        <Link to="/profile/edit" className="edit-link">
          <img src={icon} alt="수정" />
          <p>수정</p>
        </Link>
      </div>
      <div className="profile-card">
        <div className="profile-avatar">
          <div className="avatar-circle" translate="no">
            {user?.displayName?.charAt(0) || 'U'}
          </div>
        </div>
        <div className="profile-info">
          <div className="profile-details">
            <h3>{_.get(user, 'displayName', '사용자')}</h3>
            <p>{_.get(user, 'fullName')}</p>
            <p translate="no">{_.get(user, 'email')}</p>
            <div className="referral-code-container">
              <p>
                나의 추천인 코드: <span translate="no">{_.get(user, 'referralCode')}</span>
              </p>
              <button onClick={handleCopy} className="copy-btn">
                {isCopied ? '복사 완료!' : '복사'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UserProfileCard;
